exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PageWrapper-module__pagewrapper___23SDC{padding-top:60px}@media only screen and (min-width:900px){.PageWrapper-module__pagewrapper___23SDC{padding-left:0;box-sizing:border-box;padding-top:60px;margin-left:80px}.PageWrapper-module__pagewrapper___23SDC.PageWrapper-module__openSidebar___2y_39{margin-left:215px!important}}", ""]);

// exports
exports.locals = {
	"pagewrapper": "PageWrapper-module__pagewrapper___23SDC",
	"openSidebar": "PageWrapper-module__openSidebar___2y_39"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--6-1!./node_modules/sass-loader/lib/loader.js!./resources/assets/components/UI/PageWrapper/PageWrapper.module.scss
// module id = 1WcK
// module chunks = 0